import React from 'react';

import PanelRedesSociales from '../Utilitarios/PanelRedesSociales/index';
import NavBar from '../Utilitarios/NavBar/index';
import PanelCardEspeciales from '../Utilitarios/PanelCardEspeciales/index';
import BannerPublicaciones from '../Utilitarios/BannerPublicaciones/index';
import Footer from '../Utilitarios/Footer/index';

import './css/styles.css';

class Especiales extends React.Component{

    constructor(props){
        super(props);
        this.scrollUp = this.scrollUp.bind(this);
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        document.addEventListener('DOMContentLoaded', function () {
            const M = window.M;
            let elems = document.querySelectorAll('.dropdown-trigger');
            let instances = M.Dropdown.init(elems, {
                constrainWidth: false,
                coverTrigger: false,
            });
        });
    }

    scrollUp(){
        window.scrollTo(0, 0);
    }

    render(){

        return(
            <div className="container_especiales">
                <PanelRedesSociales />
                <NavBar />
                <PanelCardEspeciales />
                <BannerPublicaciones />
                <Footer />
                <a class="btn-floating btn-large waves-effect waves-light pink button_top_all"
                   onClick={this.scrollUp}>
                    <i class="material-icons">expand_less</i>
                </a>
            </div>
        );
    }
}

export default Especiales;